module.exports = __webpack_public_path__ + "static/media/Nasus_0.90d97313.jpg";